import React from 'react';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import intl from 'react-intl-universal';

export const MaintenanceSchedulePres = ({ maintenance, setMaintenanceScheduleRead }) => (
  <ConfirmDialog
    confirmText={intl.get('maintenance.confirmText')}
    noCancel={true}
    noMaxWidthBtns={false}
    open={!maintenance.isRead}
    onConfirm={() => setMaintenanceScheduleRead()}
    styleType="maintenance"
    title={intl.get('maintenance.dialogTitle')}>
    <span>{intl.get('maintenance.dialogMessage')}</span>
    <span className="downtime-begin">
      <b>{intl.get('maintenance.downtimeBegins')}</b>
      {maintenance.startDate}
    </span>
    <span className="downtime-end">
      <b>{intl.get('maintenance.downtimeEnds')}</b>
      {maintenance.endDate}
    </span>
  </ConfirmDialog>
);



// WEBPACK FOOTER //
// ./src/ui/features/Maintenance/presentational/MaintenanceSchedulePres.js